export const GET_APPLICATION_TEMPLATES_FAILED = "error:workshop.get-application-templates"
export const GET_APPLICATION_TEMPLATE_VERSIONS_FAILED = "error:workshop.get-application-template-versions"
export const GET_APPLICATION_TEMPLATE_VERSION_FAILED = "error:workshop.get-application-template-version"
export const GET_APPLICATION_TEMPLATE_FAILED = "error:workshop.get-application-template"
export const GET_APPLICATION_TEMPLATE_ALL_VERSIONS_FAILED = "error:workshop.get-application-template-all-versions"
export const GET_APPLICATIONS_FAILED = "error:workshop.get-applications"

export const CREATE_APPLICATION_TEMPLATE_FAILED = "error:workshop.create-application-template"
export const CREATE_APPLICATION_TEMPLATE_VERSION_FAILED = "error:workshop.create-application-template-version"
export const UPDATE_APPLICATION_TEMPLATE_FAILED = "error:workshop.update-application-template"
export const UPDATE_APPLICATION_FAILED = "error:workshop.update-application"
export const CHANGE_APPLICATION_TEMPLATE_STATUS_FAILED = "error:workshop.change-application-template-status"

export const RELEASE_APPLICATION_TEMPLATE_FAILED = "error:workshop.release-application-template"

export const DELETE_APPLICATION_TEMPLATE_FAILED = "error:workshop.delete-application-template"
export const DELETE_APPLICATION_TEMPLATE_VERSION_FAILED = "error:workshop.delete-application-template-version"
export const DELETE_APPLICATION_INSTANCE_FAILED = "error:workshop.delete-application-instance"
